import { render, staticRenderFns } from "./dataBattleReport.vue?vue&type=template&id=276780b2&scoped=true"
import script from "./dataBattleReport.vue?vue&type=script&lang=js"
export * from "./dataBattleReport.vue?vue&type=script&lang=js"
import style0 from "./dataBattleReport.vue?vue&type=style&index=0&id=276780b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276780b2",
  null
  
)

export default component.exports